import { AUTH_BASE_URL } from '../config/api';

const API_BASE_URL = AUTH_BASE_URL;

export const loadSettings = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/settings`, {
      credentials: 'include',
    });
    if (!response.ok) {
      throw new Error('Failed to load settings');
    }
    return await response.json();
  } catch (error) {
    console.error('Error loading settings:', error);
    // Return default settings if server is not available
    return { modelGroups: [] };
  }
};

export const saveSettings = async (settings) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/settings`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify(settings),
    });
    
    if (!response.ok) {
      throw new Error('Failed to save settings');
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error saving settings:', error);
    throw error;
  }
};

export const fetchUserSystemPrompt = async (userId = null) => {
  try {
    const url = userId
      ? `${API_BASE_URL}/api/settings/system-prompt/${userId}`
      : `${API_BASE_URL}/api/settings/system-prompt`;

    const response = await fetch(url, {
      credentials: 'include',
    });

    if (!response.ok) {
      throw new Error('Failed to fetch system prompt');
    }

    return await response.json();
  } catch (error) {
    console.error('Error fetching system prompt:', error);
    throw error;
  }
};

export const updateUserSystemPrompt = async (systemPrompt, userId = null) => {
  try {
    const url = userId
      ? `${API_BASE_URL}/api/settings/system-prompt/${userId}`
      : `${API_BASE_URL}/api/settings/system-prompt`;

    const response = await fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({ systemPrompt }),
    });

    if (!response.ok) {
      throw new Error('Failed to update system prompt');
    }

    return await response.json();
  } catch (error) {
    console.error('Error updating system prompt:', error);
    throw error;
  }
};